import { fromJS } from 'immutable'

import { EDITTING_DOCUMENTS, EDITTING_DATA } from './constants'

export const initialState = fromJS({
  edittingDocuments: false,
  edittingData: false
})

export default function reducer(state = initialState, action) {
  switch(action.type){
    case EDITTING_DOCUMENTS:
      return state.set('edittingDocuments', action.edittingDocuments)
    case EDITTING_DATA:
      return state.set('edittingData', action.edittingData)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Data/reducer.js